import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;

  width: 100vw;
  min-height: 100vh;
  background: #fff;

  padding: 10px;

  @media (max-width: 768px) {
  }

  @media (max-width: 599px) {
  }
`;
